import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { makeStyles } from '@mui/styles'

import EmbeddedDialog from '@/components/dialogs/embedded-dialog'
import { ButtonIconSquare } from '@/modules/base/components/buttons'
import lang from '@/lang'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import { openBankAccountUpdateSetupModal } from '@/redux/ducks/banking/bankAccountSetup'
import IconReload from 'assets/images/icons/reload.svg'
import IconMahnen from 'assets/images/icons/mahnen.svg'
import { useNavigate } from 'react-router'

const ContactSetupRequiredEmbeddedDialog = (props) => {
  const navigate = useNavigate()
  const classes = useStyles(props)
  const dispatch = useDispatch()
  const { selectedBankAccount } = useSelector(state => state.banking.bankAccountList)

  const openDialog = () => {
    dispatch(openBankAccountUpdateSetupModal(selectedBankAccount.contactId))
  }

  const goToBanking = () => {
    navigate('/banking')
  }

  const onClick = selectedBankAccount ? openDialog : goToBanking

  const actions = [
    <ButtonIconSquare
      key='submitBtn'
      customClass={classes.button}
      type='submit'
      icon={IconReload}
      onClick={onClick}
      label={lang.reSetupNowButtonLabel} />,
  ]

  const title = (<span className={classes.dialogTitle}>
    <SVGIcon svg={IconMahnen} width='25px' height='25px' customClass={classes.warningIcon} />
        Aktion erforderlich</span>)

  return (
    <EmbeddedDialog
      title={title}
      actions={actions}
    >
      <h2 className={classes.title}>Zugangsart bestätigen</h2>
      <p className={classes.text}>Deine Bank hat eine neue Zugangsart freigeschaltet, die nun verwendet werden muss.</p>
      <p className={classes.text}>{lang.reSetupNowConfirmText}</p>
      <p className={classes.text}>{lang.reSetupNowPrepareText}</p>
    </EmbeddedDialog>
  )
}

const useStyles = makeStyles(theme => ({
  dialogTitle: {
    color: theme.text,
    'display': 'flex',
    'align-items': 'center',
    'justify-content': 'center',
    'font-size': '18px',
    'font-weight': '500',

  },
  title: {
    'font-size': '18px',
    'margin-top': '50px',
    'margin-bottom': '25px',
  },
  text: {
    color: theme.text,
  },
  textSubline: {
    fontSize: '10px',
    color: theme.textLight,
  },
  warningIcon: {
    'fill': theme.red,
    'margin-right': '5px',
    'margin-left': '-2px',
    paddingRight: '25px',
  },

}))

export default ContactSetupRequiredEmbeddedDialog
